import { createI18n } from 'vue-i18n';
import es from '../lang/es/cbo.json';
import en from '../lang/en/cbo.json';

const i18n = createI18n({
    locale: navigator.language || navigator.userLanguage,
    fallbackLocale: "es",
    messages: {
        es,
        'es-ES': es,
        en,
        'en-US': en
    }
});

const { t } = i18n.global;

export { i18n, t }
